import { defineComponent } from 'vue'
import SubmitBtn from '@/components/ui/SubmitBtn/SubmitBtn.vue'

export default defineComponent({
  name: 'FormActionBtns',
  components: {
    SubmitBtn,
  },
  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    reversed: {
      type: Boolean,
    },
  },
  emits: ['cancel'],
  setup() {
    return {}
  },
})
